import { useEffect, useState } from 'react';
import { API } from './apiBase';

let _cache = null;
const _subs = new Set();

const broadcast = () => _subs.forEach((fn) => fn(_cache));

const refresh = async () => {
  try {
    const r = await fetch(`${API}/api/site-media`, { cache: 'no-store' });
    if (!r.ok) return;
    _cache = await r.json();
    broadcast();
  } catch (e) { /* keep last cache */ }
};

if (typeof window !== 'undefined') {
  window.addEventListener('focus', refresh);
}

/**
 * useSiteMedia(slot) — returns `{ media: [...], transition, duration_ms, transition_ms }`
 * for the given slot. Falls back to `{ media: [] }` while loading or on miss,
 * so components can safely render their built-in default media.
 */
export const useSiteMedia = (slot) => {
  const [state, setState] = useState(_cache ? _cache[slot] : null);
  useEffect(() => {
    const handler = (c) => setState(c ? c[slot] : null);
    _subs.add(handler);
    if (!_cache) refresh();
    return () => _subs.delete(handler);
  }, [slot]);
  return state || { media: [], transition: 'fade', duration_ms: 5000, transition_ms: 900 };
};

export const refreshSiteMedia = refresh;
